import { contextFactory } from '../../../factories/contextFactory.js';

const [TabsContext, useTabsContext] = contextFactory();

export { TabsContext, useTabsContext };
//# sourceMappingURL=TabsContext.js.map
